import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join'
})

export class ArrayTransformPipe implements PipeTransform {
  /**
   * Transforms data to expected format
   * @param value - value
   * @param separator - separator
   */
  transform(value: any, separator?: string): string {
    if (typeof value === 'string') {
      value = JSON.parse(value);
    }
    return separator ? value.join(separator) : value.join();
  }

}
